import React from "react";
import ChangeCategoryCard from "./ChangeCategoryCard";
import styles from "./diffChanges.module.scss";
const changeLine = (value) => (React.createElement("div", { key: value, className: styles["change-line"] }, value));
const IndicatorChanges = ({ indicators, }) => {
    const added = indicators
        .filter((change) => change.change !== "removed")
        .map((change) => changeLine(change.current));
    const removed = indicators
        .filter((change) => change.change === "removed")
        .map((change) => changeLine(change.previous));
    return (React.createElement(ChangeCategoryCard, { title: "Behaviors", added: added, removed: removed }));
};
export default IndicatorChanges;
//# sourceMappingURL=IndicatorChanges.js.map